import { TooltipText } from '@/components/tooltip-text';
import { Box, Card, CardBodyProps, CardRootProps, HStack, Icon, Stack, VStack } from '@chakra-ui/react';
import { ReactElement } from 'react';

export const CardWithToolip = ({
  icon,
  iconColor,
  iconBgColor,
  title,
  titleTooltip,
  body,
  slotRight,
  slotBottom,
  cardBodyProps,
  ...otherProps
}: {
  icon?: ReactElement;
  iconColor?: string;
  iconBgColor?: string;
  title: string;
  titleTooltip: string;
  body: ReactElement | string | number;
  slotRight?: ReactElement;
  slotBottom?: ReactElement;
  cardBodyProps?: CardBodyProps;
} & CardRootProps) => {
  return (
    <Card.Root w="full" borderRadius="2xl" flex={1} {...otherProps}>
      <Card.Body {...cardBodyProps}>
        <Stack
          justifyContent="space-between"
          direction={['column', 'column', 'row']}
          alignItems={['start', 'start', 'center']}
        >
          <HStack gap={4}>
            {icon && (
              <Icon
                asChild
                bgColor={iconBgColor ? iconBgColor : 'bg.muted'}
                color={iconColor ? iconColor : 'fg'}
                boxSize={12}
                padding={2.5}
                borderRadius="2xl"
              >
                {icon}
              </Icon>
            )}
            <VStack flex={1} alignItems="start">
              <TooltipText text={title} content={titleTooltip} fontSize={'sm'} />
              <Box fontFamily="Lufga, sans-serif" fontWeight={'500'} fontSize={'lg'}>
                {body}
              </Box>
            </VStack>
          </HStack>
          <Box display={['none', 'none', 'initial']}>{slotRight}</Box>
        </Stack>
        {slotBottom && slotBottom}
      </Card.Body>
    </Card.Root>
  );
};
